<div class="flex flex-column gap-1">
  @for (menuItem of items(); track menuItem){
    @if (menuItem?.items){
      @for (firstChildMenuItem of menuItem?.items; track firstChildMenuItem){
        @if (firstChildMenuItem?.items){
          <div>
            <bs-menu-item
              [label]="firstChildMenuItem.label"
              [items]="firstChildMenuItem.items"
            ></bs-menu-item>
          </div>
        } @else {
          <bs-menu-item
            [label]="firstChildMenuItem.label"
            [routerLink]="firstChildMenuItem.routerLink"

          ></bs-menu-item>
        }
      }
    } @else {
      <bs-menu-item
        [label]="menuItem.label"
        [routerLink]="menuItem.routerLink"
      ></bs-menu-item>
    }
  }
</div>
